import fetchDataLimits from './getDataLimits';
import watchDeleteDatalimit from './deleteDatalimit';

const watchDataLimits = [fetchDataLimits, watchDeleteDatalimit];

export default watchDataLimits;
